import { Component, Input, HostBinding, OnInit } from '@angular/core';
import { MatProgressSpinner, ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Component({
  selector: 'mat-spinner-icon',
  templateUrl: './mat-spinner-icon.component.html',
  styleUrls: ['./mat-spinner-icon.component.scss']
})
export class MatSpinnerIconComponent extends MatProgressSpinner implements OnInit {

	mode: ProgressSpinnerMode = 'indeterminate';

	@Input('class') spinerClass: string
	@Input('style') spinerStyle: string

	@HostBinding('style.font-size') fontSize: string = `${this.diameter * .6}px`;
	@HostBinding('style.width') width: string = `${this.diameter}px`;

	ngOnInit () {
		this.fontSize = `${this.diameter * .6}px`;
		this.width = `${this.diameter}px`;
	}
}
